module.exports = __webpack_public_path__ + "img/1291b54.jpg";